import { Box } from '@mui/material';
import { isTimelineMinutesVisible, minutesToTimelinePercent } from '../../../helpers/time';
import { LABEL_WIDTH } from '../layout';

type CurrentTimeMarkerProps = Readonly<{
  currentMinutes: number | null;
}>;

const CURRENT_TIME_MARKER_SX = {
  pointerEvents: 'none',
  position: 'absolute',
  left: LABEL_WIDTH,
  right: 8,
  zIndex: 5,
  height: 0,
  borderTop: '1px dashed var(--mui-palette-primary-main)',
  transform: 'translateY(-50%)',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: -4,
    top: -1,
    width: 8,
    height: 8,
    borderRadius: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'var(--mui-palette-primary-main)',
  },
} as const;

const CurrentTimeMarker = ({ currentMinutes }: CurrentTimeMarkerProps) => {
  if (!isTimelineMinutesVisible(currentMinutes)) {
    return null;
  }

  return <Box sx={{ ...CURRENT_TIME_MARKER_SX, top: `${minutesToTimelinePercent(currentMinutes)}%` }} />;
};

export default CurrentTimeMarker;
